import Web3Modal from "web3modal";
import WalletConnectProvider from "@walletconnect/web3-provider";

const getProviderOptions = () => {
  const providerOptions = {
    walletconnect: {
      package: WalletConnectProvider,
      options: {
        //infuraId: process.env.REACT_APP_INFURA_ID
        rpc: {
          56: "https://bsc-dataseed.binance.org",
          97: "https://bsc-testnet-rpc.publicnode.com",
          11155111: "https://endpoints.omniatech.io/v1/eth/sepolia/public",
          4681: "https://openzk-testnet.rpc.caldera.xyz/http",
          // 11112: "https://www.rpc.openzkbeta.click/",
        }
      }
    }
  }

  return providerOptions;
}

const web3Modal = new Web3Modal({
  cacheProvider: true,
  providerOptions: getProviderOptions() // required
});


const initialState = {
  loading: false,
  address: "",
  connected: false,
  web3: null,
  OCOVesting : null,
  OCOToken : null,
  BUSDToken : null,
  provider: null,
  token: null,
  errorMsg: null,
  reward: null,
  web3Modal
}

const walletConnectReducer = (state = initialState, action) => {
  switch (action.type) {
  case "CONNECTION_REQUEST":
    return {
      ...initialState,
      loading: true,
    };
  case "CONNECTION_SUCCESS":
    return {
      ...state,
      loading: false,
      address: action.payload.address,
      reward: action.payload.reward,
      web3: action.payload.web3,
      OCOVesting : action.payload.OCOVesting,
      OCOToken : action.payload.OCOToken,
      BUSDToken : action.payload.BUSDToken,
      provider: action.payload.provider,
      connected: action.payload.connected
    };
  case "CONNECTION_FAILED":
    return {
      ...initialState,
      loading: false,
      errorMsg: action.payload,
    };
  case "UPDATE_ADDRESS":
    return {
      ...state,
      address: action.payload.address,
    };
  default:
    return state;
  }
};

export default walletConnectReducer;
  